export default __webpack_public_path__ + "static/media/872.55f9bb1f.jpg";